import { customElement, property } from 'lit/decorators.js'

import { LitElement } from 'lit'

@customElement('ox-scene-property')
export default class OxSceneProperty extends LitElement {
  @property({ type: String }) name!: string
  @property({ type: String }) value!: string
  @property({ type: String }) type!: string
}
